import { TaskDefinition } from "../backend/types/task.ts"

export enum Panels {
    MONEY_FLOW = 'Moneyflow',
    DETAILS = 'Details',
    //SUMMARY = 'Summary',
    TRANSACTIONS = 'Transactions'
}



export const COLLAPSED_MENU_WIDTH = 72
export const MENU_WIDTH = 305
export const HEADER_HEIGHT = 64
export const CONTROL_HEIGHT = 60

export enum DateFormat {
    ISO8601 = 'YYYY-MM-DDTHH:mm:ss',
    REPORT = 'DD/MM/YYYY hh:mm A',
    REPORT_SUMMARY = 'DD MMM YYYY | hh:mm A',
    FULL = 'DD/MM/YYYY HH:mm:ss',
    DATE = 'DD MMM YYYY',
    DATE_SHORT = 'DD/MM/YYYY'
}

export const NEW_CASE_TAGS = [
    "scam",
    "hack",
    "phishing",
    "investments scam",
    "pig butchering",
    "ransomware",
    "fraud",
    "ponzi",
    "money laundering",
    "exploit"
]

export const HUMAN_READABLE_TASK_TYPE: Record<TaskDefinition, string> = {
    [TaskDefinition.Autotrace]: "Auto-tracing",
    [TaskDefinition.Trace]: "Tracing",
    [TaskDefinition.Report]: "Report generation",
    [TaskDefinition.EntityResolution]: "Force entity resolution"
}

export const DEPTH_TOOLTIP = 'Depth is measured in relation to the origin. ' +
    'For instance, a depth of in-1 indicates that the entity has directly sent money to the origin, ' +
    'while a depth of out-1 signifies that the entity has directly received money from the origin.'
